"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getDefaultRooms = getDefaultRooms;
exports.getPlace = void 0;
exports.getSearchResultsPageSize = getSearchResultsPageSize;
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _api = require("@whitbread-eos/api");
var _hooks = require("../hooks");
var _logger = require("../logger/logger");
var _RedisStorageServer = require("../storage/RedisStorageServer");
var _getters = require("./getters");
var getPlace = (multiSearchParams, language) => {
  var _multiSearchParams$co;
  var place = {
    location: multiSearchParams !== null && multiSearchParams !== void 0 && multiSearchParams.placeId ? multiSearchParams.placeId : (_multiSearchParams$co = multiSearchParams === null || multiSearchParams === void 0 ? void 0 : multiSearchParams.coordinates) !== null && _multiSearchParams$co !== void 0 ? _multiSearchParams$co : '',
    locationFormat: multiSearchParams !== null && multiSearchParams !== void 0 && multiSearchParams.placeId ? 'PLACEID' : 'LATLONG',
    radius: language === _api.LanguageEnum.ENGLISH ? 30 : 50,
    radiusUnit: (0, _getters.getDistanceUnitBasedOnLocale)(language !== null && language !== void 0 ? language : _api.LanguageEnum.ENGLISH)
  };
  return place;
};
exports.getPlace = getPlace;
function getDefaultRooms(query) {
  var noOfRooms = Number(query.ROOMS);
  if (!noOfRooms) {
    return [{
      adults: 1,
      children: 0,
      shouldIncludeCot: false,
      roomType: 'DB'
    }];
  }
  var defaultRooms = [];
  for (var idx = 0; idx < noOfRooms; idx++) {
    var defaultRoom = {
      adults: Number(query["ADULT".concat(idx + 1)]),
      children: Number(query["CHILD".concat(idx + 1)]),
      shouldIncludeCot: !!Number(query["COT".concat(idx + 1)]),
      roomType: query["INTTYP".concat(idx + 1)]
    };
    defaultRooms.push(defaultRoom);
  }
  return defaultRooms;
}
function getSearchResultsPageSize(_x, _x2, _x3) {
  return _getSearchResultsPageSize.apply(this, arguments);
}
function _getSearchResultsPageSize() {
  _getSearchResultsPageSize = (0, _asyncToGenerator2.default)(function* (language, country, queryClient) {
    var redisKeyPrefix = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : _RedisStorageServer.RedisKeyPrefix.COMMON;
    _logger.logger.info({
      country,
      language
    }, 'FETCH_SEARCH_RESULTS_INFORMATION_START');
    var cachedData;
    var redisStorage;
    var cacheKey = "srp:page-size:".concat(country, "-").concat(language);
    try {
      redisStorage = _RedisStorageServer.RedisStorageServer.getInstance(redisKeyPrefix);
      cachedData = yield redisStorage.getItem(cacheKey);
    } catch (error) {
      _logger.logger.error({
        error
      }, 'FETCH_SEARCH_RESULTS_INFORMATION_REDIS_ERROR');
    }
    try {
      var _searchInformationDat, _searchInformationDat2, _redisStorage;
      if (cachedData) {
        var _searchResultsPageSize = JSON.parse(cachedData);
        _logger.logger.info({
          cacheKey,
          searchResultsPageSize: _searchResultsPageSize
        }, 'FETCH_SEARCH_RESULTS_INFORMATION_END');
        return _searchResultsPageSize;
      }
      var searchInformationData = yield queryClient.fetchQuery({
        queryKey: ['searchInformationPageSize', country, language],
        queryFn: () => (0, _hooks.graphQLRequest)(_api.SEARCH_INFORMATION_PAGE_SIZE_RESULTS, {
          country,
          language
        })
      });
      var {
        initialPageSize,
        lazyLoadPageSize
      } = (_searchInformationDat = searchInformationData === null || searchInformationData === void 0 || (_searchInformationDat2 = searchInformationData.searchInformation) === null || _searchInformationDat2 === void 0 || (_searchInformationDat2 = _searchInformationDat2.config) === null || _searchInformationDat2 === void 0 ? void 0 : _searchInformationDat2.api) !== null && _searchInformationDat !== void 0 ? _searchInformationDat : {};
      var searchResultsPageSize = {
        initialPageSize,
        lazyLoadPageSize
      };
      yield (_redisStorage = redisStorage) === null || _redisStorage === void 0 ? void 0 : _redisStorage.setItem(cacheKey, JSON.stringify(searchResultsPageSize), _api.SEARCH_RESULTS_PAGE_SIZE_REDIS_TTL);
      _logger.logger.info({
        searchResultsPageSize
      }, 'FETCH_SEARCH_RESULTS_INFORMATION_END');
      return searchResultsPageSize;
    } catch (error) {
      _logger.logger.error({
        error
      }, 'FETCH_SEARCH_RESULTS_INFORMATION_ERROR');
      return null;
    } finally {
      var _redisStorage2;
      (_redisStorage2 = redisStorage) === null || _redisStorage2 === void 0 || _redisStorage2.cleanup();
    }
  });
  return _getSearchResultsPageSize.apply(this, arguments);
}